import { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Select,
  MenuItem,
} from '@mui/material';
import { greenColor } from '../../../config/colors';
import { useTranslation } from '../../../hooks/useTranslation';

const FilterModal = ({ open, onClose, onApply, resales = [] }) => {
  const { t } = useTranslation();
  const [selectedResale, setSelectedResale] = useState('');

  const handleApply = () => {
    onApply({ resale_id: selectedResale });
    onClose();
  };

  const handleClear = () => {
    setSelectedResale('');
    onApply({});
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>{t('simulatorSuperAdmin.filterModal.title')}</DialogTitle>

      <DialogContent>
        <Typography>{t('forms.dealer')}</Typography>

        <Select
          fullWidth
          value={selectedResale}
          onChange={(e) => setSelectedResale(e.target.value)}
        >
          <MenuItem value="">{t('simulatorSuperAdmin.filterModal.all')}</MenuItem>

          {resales.map((r) => (
            <MenuItem key={r.id} value={r.id}>
              {r.name}
            </MenuItem>
          ))}
        </Select>
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClear}>{t('common.clear')}</Button>

        <Button
          onClick={handleApply}
          sx={{ bgcolor: greenColor, color: '#fff' }}
        >
          {t('common.filter')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FilterModal;
